import React from 'react';
import '../home/Home.css'

function Footer() {
  return (
    <>
      <div style={{backgroundColor:'#17B0A7', textAlign:'center', padding: '1px', color:'white'}}>
        <p>FOOTER A TRAVAILLER</p>
      </div>
    </>
  );
}
export default Footer;